import { ReactNode } from 'react';

import { Grid, GridProps } from '@mui/material';

interface FlexRowProps extends GridProps {
    children: ReactNode;
}

export default function FlexRow({ children, ...props }: FlexRowProps): JSX.Element {
    return (
        <Grid display="flex" flexDirection="row" {...props}>
            {children}
        </Grid>
    );
}
